import { CLUSTER_API } from '../API/BASE_URL';

export const getEventsSlider = async () => {
  const response = await fetch(CLUSTER_API + 'events/events-slider/', {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
